import { environment } from 'app/core/environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { SecureStorageService } from '../secure-storage/secure-storage.service';

@Injectable({
	providedIn: 'root',
})
export class UserPermissionsService {
	apiUrl = `${environment.financialUrl}/aps`;

	userId: string;

	constructor(
		private http: HttpClient,
		private secureStorage: SecureStorageService,
	) {
		this.userId =
			this.secureStorage.getItem('username') ||
			this.secureStorage.getItem('userId') ||
			'';
	}

	getPermissions() {
		if (!this.userId) {
			this.userId =
				this.secureStorage.getItem('username') ||
				this.secureStorage.getItem('userId') ||
				'';
		}

		return this.http.post<any[]>(this.apiUrl, { username: this.userId });
	}
}
